import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-header-time-payment',
    templateUrl: './header-time-payment.component.html',
    styleUrls: ['./header-time-payment.component.css'],
    standalone: false
})
export class HeaderTimePaymentComponent implements OnInit{
  @Input() step: number = 0;
  imgPaymentMethod?: string;
  imgSummaryPayment?: string;
  imgPaymentConfirm?: string;
  txtMessage?: string;
  flag?: string;

  constructor() { }

  ngOnInit() {
    if (this.step === 2) {
      this.txtMessage = 'Escoge el medio de pago';
      this.imgPaymentMethod = '../../../../assets/images/icono-02-on-1.png';
      this.imgSummaryPayment = '../../../../assets/images/icono-03-off.png';
      this.imgPaymentConfirm = '../../../../assets/images/icono-04-off.png';
      this.flag = '../../../../assets/images/icono-flecha.png';
    } else if (this.step === 3) {
      this.txtMessage = 'Realiza el pago en línea';
      this.imgPaymentMethod = '../../../../assets/images/icono-02-on-2.png';
      this.imgSummaryPayment = '../../../../assets/images/icono-03-on-1.png';
      this.imgPaymentConfirm = '../../../../assets/images/icono-04-off.png';
      this.flag = '../../../../assets/images/icono-flecha.png';
    } else if (this.step === 4) {
      this.txtMessage = 'Recibe la confirmación';
      this.imgPaymentMethod = '../../../../assets/images/icono-02-on-2.png';
      this.imgSummaryPayment = '../../../../assets/images/icono-03-on-2.png';
      this.imgPaymentConfirm = '../../../../assets/images/icono-04-on-1.png';
      this.flag = '../../../../assets/images/icono-flecha.png';
    }
  }
}
